import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {Badge} from '../badge/badge';
// @ts-expect-error - imported from .js/.jsx file
import {FilterIcon} from '../icon/svg/filter-icon';

import styles from './filter-button.module.css';

type FilterButtonProps = {
    onClick: (arg1: boolean) => any;
    isOpen: boolean;
    activeFilters: Array<FilterObject>;
    getRef?: (arg1?: HTMLElement | null | undefined) => void;
};

/*
 * Component representing the blue filter button to toggle the filter drawer,
 * seemed specific enough to live within the /reports directory
 */
export class FilterButton extends React.Component<FilterButtonProps> {
    render() {
        return (
            <button
                id='filter-button'
                ref={this.props.getRef}
                data-tip='Filter'
                onClick={this.handleClick}
                className={this.props.isOpen ? styles['container-open'] : styles.container}
            >
                <FilterIcon className={styles['filter-icon']} size={18} />
                <Badge
                    contents={this.props.activeFilters.length}
                    color='grey'
                    hideBadgeWhenEmpty={true}
                />
            </button>
        );
    }

    handleClick = () => {
        this.props.onClick(!this.props.isOpen);
    };
}
